module.exports = __webpack_public_path__ + "img/Hans.1eb3bb89.png";